function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import c from 'classnames';
import ReactDomServer from 'react-dom/server';
import { useMenu } from 'react-instantsearch';
import { FormSelect } from '@uncinc/uncinc-react-kitchen-sink';
const SearchFacetMenuSelect = props => {
  const {
    attribute,
    limit = 100,
    className,
    itemClassName,
    ...restProps
  } = props;
  const {
    items,
    canRefine,
    refine
  } = useMenu({
    ...props,
    limit,
    showMore: false
  });
  const classNames = c('Searchkit__Facet__MenuSelect', className);
  const itemClassNames = c('Searchkit__Facet__MenuSelect__item', itemClassName);
  const options = useMemo(() => items.map(item => ({
    value: item.value,
    label: ReactDomServer.renderToString(/*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__label"
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__count"
    }, item.count))),
    disabled: item.count === 0
  })), [items]);
  const defaultValue = useMemo(() => {
    const currentOption = items.find(item => item.isRefined);
    return currentOption?.value;
  }, [items]);
  if (!canRefine) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormSelect, _extends({}, restProps, {
    fieldName: `menu_${attribute}`,
    options: options,
    defaultValue: defaultValue,
    multiple: false,
    wrapperClassName: classNames,
    className: itemClassNames,
    onChange: value => {
      refine(value);
    }
  }));
};
export default SearchFacetMenuSelect;